import axiosBase from 'axios'

const api = axiosBase.create({
    baseURL: 'http://localhost:8010',

    timeout: 20000,
    headers: { 'Accept': 'application/json' }
});

export default api